import { ReactNode } from 'react'
import { Input } from '@/components'
import {
  TableContainer,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  TableInputContainer,
} from '../CenaTable/CenaTable.styles'

export interface InteractionData {
  id: string
  label: string
  value: string
}

export interface NetworkData {
  id: string
  name: string
  interactions: InteractionData[]
}

interface UltraperformanceTableProps {
  data: NetworkData[]
  onChange: (networkId: string, interactionId: string, value: string) => void
}

export function UltraperformanceTable({ data, onChange }: UltraperformanceTableProps) {
  const renderTable = () => {
    const result: ReactNode[] = []
    let rowIndex = 0
    let groupIndex = 0

    data.forEach((network) => {
      const isEvenGroup = groupIndex % 2 === 0

      network.interactions.forEach((interaction, interactionIndex) => {
        const isFirstInGroup = interactionIndex === 0

        result.push(
          <TableRow key={`row-${rowIndex}`} $isGroupRow={isEvenGroup}>
            {isFirstInGroup && (
              <TableCell
                $width={120}
                $align="left"
                rowSpan={network.interactions.length}
                style={{ verticalAlign: 'middle', fontWeight: 500 }}>
                {network.name}
              </TableCell>
            )}
            <TableCell $align="left">{interaction.label}</TableCell>
            <TableCell $width={120} $align="center">
              <TableInputContainer>
                <Input
                  type="number"
                  value={interaction.value}
                  onChange={(value) => onChange(network.id, interaction.id, String(value))}
                />
              </TableInputContainer>
            </TableCell>
          </TableRow>,
        )
        rowIndex++
      })
      groupIndex++
    })

    return result
  }

  return (
    <TableContainer>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <TableHeader>
          <tr>
            <TableCell as="th" $width={120} $align="left" $isHeader style={{ padding: '12px 16px', fontWeight: 600 }}>
              Rede
            </TableCell>
            <TableCell as="th" $align="left" $isHeader style={{ padding: '12px 16px', fontWeight: 600 }}>
              Interação
            </TableCell>
            <TableCell as="th" $width={120} $align="center" $isHeader style={{ padding: '12px 16px', fontWeight: 600 }}>
              Multiplicador
            </TableCell>
          </tr>
        </TableHeader>
        <TableBody as="tbody">{renderTable()}</TableBody>
      </table>
    </TableContainer>
  )
}
